import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNotification } from "../../components/notification/NotificationContainer";
import { getCountries } from "../../features/countriesSlice";
import { closeModal } from "../../features/modalSLice";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import Loading from "../../components/loading/Loading";
import AddResource from "../../components/header/AddResource";
import InputField from "../../components/form/InputField";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import {
  addMethodType,
  editMethodType,
} from "../../features/transactionsSlice";

const AddMethodType = ({ id, edit }) => {
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const methodType = useSelector((state) => state.transactions.selectedType);
  const typeLoad = useSelector(
    (state) => state.transactions.load.getMethodType
  );
  const addTypeLoad = useSelector(
    (state) => state.transactions.load.addMethodType
  );
  const editTypeLoad = useSelector(
    (state) => state.transactions.load.editMethodType
  );

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    // resolver: zodResolver(addMethodTypeSchema),
    defaultValues: { name: "" },
  });

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      if (edit) {
        const res = await dispatch(editMethodType({ id, data: data }));

        if (editMethodType.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Type Updated Successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      } else {
        const res = await dispatch(addMethodType(data));
        if (addMethodType.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Type Added Successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  // useEffect(() => {
  //   dispatch(getCountries());
  // }, []);

  useEffect(() => {
    if (methodType.id && edit) {
      reset({
        province_id: methodType.province_id,
        name: methodType.name,
      });
    }
  }, [methodType]);

  if (typeLoad && edit) {
    return (
      <div className="min-w-72 sm:min-w-96 lg:min-w-96 w-full h-96">
        <Loading />
      </div>
    );
  }

  return (
    <div className="min-w-72 sm:min-w-[26rem] lg:min-w-96">
      <AddResource
        title={edit ? "Edit Transaction Type" : "Add Transaction Type"}
      />
      <form
        autoCorrect="off"
        autoComplete="off"
        aut
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col justify-center items-center gap-2 w-full">
          <InputField
            register={register}
            type="text"
            autoComplete="off"
            label="Name"
            name="name"
            errors={errors.name}
          />
        </div>
        {/* <div className="flex items-center justify-end py-6">
          <button className="add-rss-btn" type="submit">
            Submit
          </button>
        </div> */}
        <ResourseButtons loading={addTypeLoad || editTypeLoad} />
      </form>
    </div>
  );
};

export default AddMethodType;
